import React from "react";
import { useNavigate } from "react-router-dom";
import { TeamOutlined, CalendarOutlined } from "@ant-design/icons";
import AppLayout from "../components/Layout";
import ScenarioCard, { TileGrid } from "../components/ScenarioCard";

const ModeSelection = () => {
	const navigate = useNavigate();
	return (
		<AppLayout title="Welcome" subtitle="Choose how you want to work today.">
			<TileGrid $maxWidth="720px" style={{ marginTop: 24 }}>
				<ScenarioCard
					icon={<TeamOutlined />}
					title="User mode"
					description="Add individual contacts and launch VR scenarios for them."
					onClick={() => navigate("/users/students")}
				/>
				<ScenarioCard
					icon={<CalendarOutlined />}
					title="Event mode"
					description="Run an event: create it, add contacts and track results."
					onClick={() => navigate("/events")}
				/>
			</TileGrid>
		</AppLayout>
	);
};

export default ModeSelection;
